import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SubLinks } from '../navigation/sublinks';

@Component({
    selector: 'my-sub-navigation',
    templateUrl: 'sub-navigation.component.html',
    styleUrls: ['sub-navigation.component.scss']
})


export class SubNavigationComponent {

    @Input() subLinks: SubLinks[];

    @Output() action: EventEmitter<string> = new EventEmitter();

    takeAlternateAction(altAction: string){
        setTimeout(() => {
            this.action.next(altAction);
        })
    }
}